<div class="lifetime-expense" [class.lifetime-expense--small]="size === 'small'">
    <header class="lifetime-expense__header">
        <div class="header-top-row">
            <div class="lifetime-expense__title">{{ title }}</div>
        </div>

        <div class="header-bottom-row">
            <div class="pagination-indicator" *ngIf="rates.length > visibleItemsCount">
                {{ paginationText }}
            </div>

            <div class="header-actions">
                <!-- Navigation -->
                <div class="nav-controls" *ngIf="rates.length > visibleItemsCount">
                    <div class="nav-btn" [class.disabled]="!canGoPrev"
                        (click)="canGoPrev && prev(); $event.stopPropagation()">
                        <img src="assets/icons/arrow-white-left.svg" alt="Prev" />
                    </div>
                    <div class="nav-btn" [class.disabled]="!canGoNext"
                        (click)="canGoNext && next(); $event.stopPropagation()">
                        <img src="assets/icons/arrow-white-right.svg" alt="Next" />
                    </div>
                </div>

                <!-- Edit Pencil (only in edit mode) -->
                <ng-container *ngIf="isEditMode">
                    <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()"
                        cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
                        <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
                    </div>
                    <app-widget-edit [editTrigger]="editTrigger" [index]="index"
                        [activeDropdownIndex]="activeDropdownIndex" [getAvailableSizes]="getAvailableSizes"
                        [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
                        [toggleSizeDropdown]="toggleSizeDropdown">
                    </app-widget-edit>
                </ng-container>

                <ng-container *ngIf="isAddMode">
                    <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                        alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
                </ng-container>
            </div>
        </div>
    </header>

    <div class="lifetime-expense__content">
        <div class="lifetime-expense__viewport">
            <div class="lifetime-expense__list"
                [style.transform]="'translateX(-' + (currentIndex * (100 / visibleItemsCount)) + '%)'">
                <div class="rate-item" *ngFor="let rate of rates"
                    [style.flex]="'0 0 ' + (100 / visibleItemsCount) + '%'">
                    <div class="rate-item__card">
                        <div class="flag-wrapper">
                            <img [src]="rate.icon" class="flag-icon" [alt]="rate.code" />
                        </div>
                        <div class="rate-details">
                            <div class="rate-conversion">
                                <div class="rate-from">{{ rate.from }}</div>
                                <div class="rate-to">{{ rate.to }}</div>
                            </div>
                            <div class="rate-info">
                                <span class="info-label">{{ rate.bank }}</span>
                                <span class="info-separator">/</span>
                                <span class="info-label">{{ rate.value }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>